import * as React from "react";
import { SVGProps } from "react";

const Hackenai = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 58" {...props}>
    <path
      fill="#4adda5"
      fillRule="evenodd"
      d="M6 52.41V58H4.21v-2H1.75v2H0v-5.58h1.75v1.9h2.46v-1.91Zm18.75 0V54h-4.67v2.41h4.64V58h-6.39v-5.58h6.39Zm23.07 0 2.44 2.41v-2.41H52V58h-1.76l-2.45-2.48V58H46v-5.59Zm-14.12 0v1.91L32 56h1.7v2h-1.86v-2h-2.73v2h-1.83v-5.58h1.83v1.9h2.73v-1.91Zm-18.7 0h.3V58h-1.7v-1.21h-2.48V58H9.38v-5.58H15Zm27.58 0V54H38.4v.42h4.21V56H38.4v.42h4.21V58h-6v-5.58h6ZM13.6 54h-2.48v1.14h2.48ZM3 0v23.11h3V0h3v23.11h40v-3.35H12.36V0h3v16.71H49v-3H17.9V0h3v10.67h9.77V0h3v10.67h3V0h3v10.67h3.41V0h3v10.67h3V0h3v49H49V26.21h-3.39V49h-3V26.21H3v3h36.64V49h-3V32.27H3v3h31.1V49h-3V38.31h-9.79V49h-3V38.31h-3V49h-3V38.31H9V49H6V38.31H3V49H0V0Z"
    />
  </svg>
);

export default Hackenai;
